<template>
    <div>
        <h1 style="font-size: 24px; color: black;">发现页管理 </h1>
        <h3>共{{ totalSize }}条</h3>
        <div style="margin-bottom: 10px;">
            <el-row>
                <span> 渠道： </span>
                <el-cascader v-model="queryData.subChannels" :options="channelList" :props="optionProps" clearable
                             collapse-tags>
                </el-cascader>
                <el-button class="margin-left-10" type="primary" @click="searchListMatch">查询</el-button>
                <el-button type="primary" @click="handleEdit('新增发现页配置')">新增发现页配置</el-button>
            </el-row>
        </div>
        <div>
            <el-table
                border
                :fit="true"
                :row-class-name="tableRowClass"
                :data="rules">
                <el-table-column prop="id" label="板块ID"></el-table-column>
                <el-table-column prop="name" label="板块名称"></el-table-column>
                <el-table-column label="绑定渠道" :width="300" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{
                            scope.row.subChannels.length === subChannels.length ? '全部' : scope.row.subChannelNames.join(" , ")
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="选品总数"></el-table-column>
                <!-- <el-table-column prop="recommendCount" label="系统推荐数"></el-table-column> -->
                <el-table-column label="开关" align="center" width="150px">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.state"
                                   :active-value="1"
                                   :inactive-value="0"
                                   active-text="开启"
                                   inactive-text="关闭"
                                   @change="update(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="是否归因" align="center" width="150px">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.clicked"
                                   :active-value=true
                                   :inactive-value=false
                                   active-text="归因"
                                   inactive-text="未归因"
                                   @change="updateClicked(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="260px">
                    <template slot-scope="scope">
                        <el-row>
                            <el-button size="mini" type="info" @click="refresh(scope.row.id)">刷新</el-button>
                            <el-button size="mini" type="warning" @click="showWeight(scope.row)">权重</el-button>
                            <el-button size="mini" type="primary" @click="handleEdit('编辑游戏匹配',scope.row)">编辑
                            </el-button>
                        </el-row>
                        <el-button size="mini" type="success" @click="showSelectorDialog(scope.row)">选品</el-button>
                        <el-button size="mini" @click="copyRow(scope.row)">复制</el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-dialog :title="editDialogTitle"
                       center
                       :visible.sync="editDialogVisible"
                       @close="editDialogVisible=false"
                       width="500px">
                <el-form :model="matchEditForm">
                    <el-form-item label="板块名称" :label-width="labelWidth">
                        <el-input style="width: 220px" type="text" v-model="matchEditForm.name"></el-input>
                    </el-form-item>

                    <el-form-item label="渠道选择" :label-width="labelWidth">
                        <el-cascader v-model="matchEditForm.subChannels" :options="channelList" :props="optionProps"
                                     clearable collapse-tags placeholder="默认全选">
                        </el-cascader>
                    </el-form-item>
                    <!-- <el-form-item label="系统推荐数 :"  :label-width="labelWidth">
                        <el-input-number :min="0" :step="1" v-model="matchEditForm.recommendCount"></el-input-number>
                    </el-form-item> -->
                    <el-form-item width="100" label="是否归因:">
                        <el-switch v-model="matchEditForm.clicked"
                                   :active-value=true
                                   :inactive-value=false
                                   active-text="开启"
                                   inactive-text="关闭">
                        </el-switch>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmEditFormDialog">确 定</el-button>
                        <el-button type="info" @click="cancleEditFormDialog">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
        <div>
            <el-dialog title="权重配置" center
                       :visible.sync="weightDialogVisible"
                       @close="weightDialogVisible=false"
                       @open="getData" width="800px">
                <el-card class="form-container" shadow="never">
                    <el-row :gutter="8">
                        <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1"></el-col>
                        <el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11"><h2>版块ID:{{ getData().id }}</h2></el-col>
                        <el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11"><h2>版块名称:{{ getData().name }}</h2></el-col>
                        <el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1"></el-col>
                    </el-row>
                </el-card>
                <el-card class="form-container" shadow="never">
                    <el-form>
                        <el-form-item>
                            <el-button type="primary" @click="addWeight(getData().id)">添加</el-button>
                        </el-form-item>
                        <el-table :data="list"
                                  border>
                            <el-table-column label="权重" align="center">
                                <template slot-scope="scope">
                                    <el-input-number :min="0" v-model="scope.row.weight"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="外显数量" align="center">
                                <template slot-scope="scope">
                                    <el-input-number :min="0" v-model="scope.row.number"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-button circle icon="el-icon-minus" size="mini" type="danger"
                                               @click.native.prevent="reduceCash(scope.$index,list)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <h4 style="text-align: center;">
                            <el-button type="primary" @click="confirmWeight(getData().id)">确 定</el-button>
                            <el-button type="info" @click="cancelWeight">取 消</el-button>
                        </h4>
                    </el-form>
                </el-card>
            </el-dialog>
        </div>
        <div>
            <el-dialog title="视频选品"
                       center
                       :visible.sync="selectorDialogVisible"
                       @open="matchInfo"
                       @close="selectorDialogVisible=false"
                       :close-on-click-modal="false"
                       :show-close="false"
                       :destroy-on-close="true"
                       width="1500px">
                <h4>当前版块名称:<font size="6" bold>{{ plateInfo().name }}</font></h4>
                <div style="margin-bottom: 10px;">
                    <span>游戏名称：</span>
                    <el-select v-model="queryGameSelector.gameIds" multiple filterable placeholder="请选择/输入">
                        <el-option
                            v-for="item in gameSelectorList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <span>业务类型：</span>
                    <!-- 默认查询业务为208 -->
                    <el-select v-model="queryGameSelector.dept" clearable placeholder="请选择/输入">
                        <el-option
                            v-for="item in deptConst"
                            :key="item.id"
                            :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span> 游戏标签：</span>
                    <el-cascader v-model="queryGameSelector.gameLabels" :options="labelList"
                                 :props="{ key:'id',value:'id', label:'name',multiple:true }" clearable
                                 collapse-tags></el-cascader>
                    <el-button type="primary" @click="queryGameList">查询</el-button>
                    <br>
                    <!-- <span >记录日期：</span>
                     <el-date-picker
                             v-model="searchDateRange"
                             type="daterange"
 :clearable="false"
                             :picker-options="pickerOptions"
                             format="yyyy-MM-dd"
                             value-format="yyyy-MM-dd"
                             range-separator="至"
                             start-placeholder="开始日期"
                             end-placeholder="结束日期">
                     </el-date-picker>
                     <br>
                     <span >渠道筛选：</span>
                     <el-cascader v-model="queryGameSelector.subChannelIds" :options="channelList" :props="optionProps" clearable collapse-tags >
                     </el-cascader>-->

                    <table>
                        <tr>
                            <td>
                                <el-button type="primary" @click="clearAllSelected">一键清除</el-button>
                            </td>
                            <td>
                                <el-button type="primary" @click="exportExcel">导出</el-button>
                            </td>
                            <td>
                                <el-upload :action="upload()" :headers="headers"
                                           :on-success="handleSuccess"
                                           :before-upload="beforeUpload"
                                           :show-file-list="false"
                                           v-loading.fullscreen.lock="loading" :disabled="disable"
                                           ref="upload">
                                    <el-button size="medium" type="primary" :disabled="disable">导入</el-button>
                                    <span
                                        style="color:crimson">当前只能导入一次， 导入成功后如需重新导入请关闭页面后，再重新打开。</span>
                                </el-upload>
                            </td>
                        </tr>
                    </table>
                </div>
                <template>
                    <h4>选择视频</h4>
                    <el-table border
                              ref="multipleTable"
                              :data="gameList"
                              :row-class-name="gameRowTableClass"
                              stripe
                              tooltip-effect="dark"
                              style="width: 100%"
                              :row-key="getRowKeys"
                              @selection-change="handleSelectionChange"
                              @sort-change="sort_change"
                    >
                        <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
                        <el-table-column type="index" label="编号" width="50"></el-table-column>
                        <el-table-column prop="gameId" :formatter="formatGameId" label="游戏名称"></el-table-column>
                        <el-table-column prop="dept" label="业务类型"></el-table-column>
                        <!--<el-table-column label="视频缩略图">
                        <template v-if="scope.row.imagePath" slot-scope="scope">
                            <img :src="VUE_APP_CDN_URL+scope.row.imagePath" width="80px" height="80px" alt=""/>
                        </template>
                        </el-table-column>-->
                        <!--<el-table-column label="视频">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showVideo(scope.row.videoPath)">查看视频</el-button>
&lt;!&ndash;                            <video :src="VUE_APP_CDN_URL+scope.row.videoPath" class="avatar1" controls="controls"/>&ndash;&gt;
                        </template>
                        </el-table-column>-->
                        <el-table-column prop="name" label="视频名称"></el-table-column>
                        <!-- <el-table-column prop="clRate" sortable="custom" label="用户点击率" :formatter="formatterPercent" >
                            </el-table-column>
                            <el-table-column prop="clUser"  sortable="custom" label="点击用户数" :formatter="formatterCount" >
                            </el-table-column>
                         <el-table-column prop="exRate" sortable="custom" label="曝光率" :formatter="formatterPercent" >
                            </el-table-column>-->
                        <el-table-column sortable="custom" prop="dtCreate" :formatter="formatDate"
                                         label="创建时间"></el-table-column>
                    </el-table>
                    <div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryGameSelector.page"
                            :page-sizes="[5, 10,30,50,70,90,100]"
                            :page-size="queryGameSelector.size"
                            layout="total, sizes, prev, pager, next"
                            :total="totalElements">
                        </el-pagination>
                    </div>
                </template>
                <template v-if="selectedGameList.length>0">
                    <h4>已经选择的游戏</h4>
                    <el-table border
                              height="600"
                              :data="selectedGameList"
                              tooltip-effect="dark"
                              style="width: 100%"
                              :header-cell-class-name="handleHeaderClass"
                              @header-click="handleHeaderCLick"
                              @sort-change="handleTableSort">
                        <el-table-column
                            type="index"
                            label="编号"
                            width="50">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="游戏名称">
                        </el-table-column>
                        <!-- <el-table-column label="视频缩略图">
                        <template v-if="scope.row.imagePath" slot-scope="scope">
                            <img :src="VUE_APP_CDN_URL+scope.row.imagePath" width="80px" height="80px" alt=""/>
                        </template>
                        </el-table-column>-->
                        <!-- <el-table-column label="视频">
                        <template slot-scope="scope">
                            <video :src="VUE_APP_CDN_URL+scope.row.videoPath" class="avatar1" controls="controls"/>
                        </template>
                        </el-table-column> -->
                        <el-table-column
                            prop="name"
                            label="视频名称">
                        </el-table-column>
                        <el-table-column label="权重" prop="weight" align="center" sortable="custom">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.weight" placeholder="请选择">
                                    <el-option @change="disable=true" :key="-1" label="0" :value="0"></el-option>
                                    <el-option @change="disable=true"
                                               v-for="item in list"
                                               :key="item.id"
                                               :label="item.weight"
                                               :value="item.weight">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="排序" prop="rank" sortable="custom" align="center">
                            <template slot-scope="scope">
                                <el-input-number size="mini" v-model="scope.row.rank"
                                                 @change="disable=true"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger"
                                           @click.native.prevent="deleteRow(scope.$index, scope.row)">移除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <el-form>
                    <el-form-item>
                        <template>
                            <div class="block">
                                <h4>设置生效时间:
                                    <el-date-picker
                                        v-model="useTime"
                                        type="datetime"
                                        placeholder="选择日期时间"
                                    >
                                    </el-date-picker>
                                </h4>
                            </div>
                        </template>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmAddSelect(selectedGameList,matchInfo().id,useTime)">确
                            定
                        </el-button>
                        <el-button type="info" @click="closeSelectorFormDialog()">返 回</el-button>
                    </div>
                </el-form>
            </el-dialog>
            <!-- <el-dialog title="视频详情"
                        center
                        :visible.sync="videoDialogVisible"
                        @open="videoInfo"
                        @close="videorDialogVisible=false"
                        width="320px">
                 <div>
                     <video :src="VUE_APP_CDN_URL+videoInfo()" style="width: 270px; height: 480px" class="avatar1" controls="controls"/>
                 </div>
             </el-dialog>-->
        </div>
    </div>
</template>

<script>
import {
    addDiscoverRule,
    allGameLabels,
    allLabels,
    batchAddDiscoverSelector,
    batchAddWeight,
    changeClickedDiscoverRule,
    changeStateDiscoverRule,
    channelList,
    deleteDiscoverRule,
    downloadData,
    editDiscoverRule,
    gameRunningList,
    refreshTime,
    searchDiscoverRules,
    searchDiscoverSelector,
    selectedDiscoverSelector,
    weightSearch
} from "@/http/api";
import utils from '@/utils'

export default {
    name: "MatrixConfig",
    data() {
        return {
            exportObject: {
                id: 0
            },
            ordersList: [],
            disable: false,
            headers: {},
            url: '',
            loading: false,
            VUE_APP_BASE_URL: null,
            checkAll: false,
            isIndeterminate: true,
            labelWidth: '100px',
            editDialogVisible: false,
            videoDialogVisible: false,
            selectorDialogVisible: false,
            weightDialogVisible: false,
            editDialogTitle: '',
            //模块编辑的数据对象
            matchEditForm: {
                "id": 0,
                "gameId": "",
                "positions": [],
                "subChannels": [],
                "recommendCount": 0,
                "clicked": null
            },
            optionProps: {
                emitPath: false,
                multiple: true,
                value: 'subChannel',
                label: 'name',
                children: 'children',
            },
            //版块列表数据
            rules: [],
            //游戏列表      todo 视频选品list  修改名称
            gameList: [],
            //每行板块
            rule: {},
            //是否为复制操作flag
            copyFlag: false,
            //最终选中的列表
            selectedGameList: [],
            //临时新增展示的列表
            tempSelectedGameList: [],
            //判断是否进行监听selectedGameList 标志位
            flag: false,
            queryGameData: {
                name: '',
                categories: [],
            },
            subQueryData: {},
            //设置当前页面总数
            totalSize: 0,
            queryData: {
                subChannels: [],
            },
            pagination: {
                size: 10,
                pageNumber: 1,
            },
            games: [],
            selectGameIds: new Set(),
            channelList: [],
            //子渠道集合
            subChannelList: [],
            //子渠道号集合
            subChannels: [],
            //子渠道名称集合
            subChannelNames: [],
            //生效时间
            useTime: '',
            //LinkedIds:new Set(),
            labels: [],
            //游戏选品中游戏列表下拉框数据 固定的
            gameSelectorList: [],
            // 游戏选品
            queryGameSelector: {
                "gameIds": [],
                "gameLabels": [],
                "gameLabelIds": [],
                "startTime": '',
                "endTime": '',
                "subChannelIds": [],
                "prop": '',
                "order": '',
                "page": 1,
                "size": 10,
                "dept": ''
            },
            //游戏选品总数
            totalElements: 0,
            //查询日期区间
            searchDateRange: [],
            pickerMinDate: '',
            pickerOptions: {
                onPick: (time) => {
                    // this.pickerMinDate = time.minDate;
                    if (time.minDate && !time.maxDate) {
                        this.pickerMinDate = time.minDate;  //将第一次选中值保存
                    }
                    if (time.maxDate) {
                        this.pickerMinDate = null;
                    }
                },
                disabledDate: (time) => {
                    if (this.pickerMinDate) {
                        const day1 = 7 * 24 * 3600 * 1000;
                        let maxTime = this.pickerMinDate.getTime() + day1;
                        let minTime = this.pickerMinDate.getTime() - day1;
                        return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() + 24 * 3600 * 1000
                    } else {
                        return time.getTime() > Date.now() + 24 * 3600 * 1000
                    }
                }
            },
            VUE_APP_CDN_URL: null,
            // 业务组常量 目前写死 todo
            deptConst: [{id: 0, name: '全部', value: null},
                {id: 1, name: '208', value: "208"},
                {id: 2, name: '211', value: "211"}],
            labelList: [],
            discoverDetails: {},
            list: [],
            orderList: []
        }
    },
    methods: {
        //格式化游戏id
        formatGameId: function (row, column, cellValue) {
            var temp = "无"
            this.gameSelectorList.forEach(item => {
                if (item.id === cellValue) {
                    temp = item.name;

                }
            })
            return temp
        },
        //带百分数的格式化
        formatterPercent: function (row, column, cellValue) {
            if (cellValue === null) {
                return "0%";
            } else {
                return (cellValue * 100).toFixed(2) + "%";
            }

        },
        //默认数字的格式化 赋值默认值为0
        formatterCount: function (row, column, cellValue) {
            if (cellValue === null) {
                return 0;
            } else {
                return cellValue;
            }
        },


        handleDelete: function (row) {
            this.$confirm('确认是否删除?', '警告', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteDiscoverRule(row.id).then(resp => {
                    if (resp.data.status === 0) {
                        this.searchListMatch();
                    }
                })
            }).catch(() => {
            })
        },
        //根据游戏id获取游戏名称

        gameRowTableClass({row, rowIndex}) {
            row.index = rowIndex
        },
        getRowKeys(row) {
            return row.id
        },
        matchInfo: function () {
            return this.rule;
        },
        videoInfo: function () {
            return this.url;
        },
        //-------------------------------------------板块相关方法
        //新增板块和 编辑板块 按钮操作方法
        handleEdit: function (title, row) {
            this.matchEditForm = {
                "id": 0,
                "name": "",
                "recommendCount": 0,
                "state": 0,
                "subChannels": [],
                "clicked": true
            };

            this.editDialogTitle = title;
            this.editDialogVisible = true;

            if (row) {
                this.matchEditForm = {
                    "id": row.id,
                    "name": row.name,
                    "recommendCount": row.recommendCount,
                    "state": row.state,
                    "subChannels": row.subChannels,
                    "clicked": row.clicked
                };
            }
        },
        //查询板块规则通用方法---------------------------------------------------------------------------板块相关方法
        searchListMatch: function () {
            let _this = this;
            searchDiscoverRules(this.queryData).then(resp => {
                this.rules = resp.data.info;
                //设置总条数
                this.totalSize = this.rules.length;
                this.rules.forEach(function (rule) {
                    if (rule.subChannels.length < 1) {
                        _this.$set(rule, 'subChannels', _this.subChannels);
                    } else {
                        rule.subChannels.forEach(function (subChannel) {
                            _this.subChannelList.forEach(function (sub) {
                                if (sub.subChannel === subChannel) {
                                    _this.subChannelNames.push(sub.name);
                                }
                            })
                        });

                        _this.$set(rule, 'subChannelNames', _this.subChannelNames);
                        _this.subChannelNames = [];
                    }
                });
            })
        },
        // 修改开关开启关闭 方法
        update(row) {
            // 修改开关更新方法 只需要传入id即可进行转换  ------------------------------------------
            changeStateDiscoverRule(row.id).then(resp => {
                if (resp.data.msg === '成功') {
                    this.searchListMatch();
                }
            });
        },
        updateClicked(row) {
            // 修改开关更新方法 只需要传入id即可进行转换  ------------------------------------------
            changeClickedDiscoverRule(row.id).then(resp => {
                if (resp.data.msg === '成功') {
                    this.searchListMatch();
                }
            });
        },
        refresh(id) {
            refreshTime(id).then(resp => {
                if (resp.data.status === 0) {
                    this.$message({
                        message: '恭喜你，刷新成功',
                        type: 'success'
                    });
                }
            });
        },
        /* showVideo:function(url){
           this.videoDialogVisible = true;
           this.url = url;
         },*/
        showSelectorDialog: function (row) {
            this.search(row.id);
            this.disable = false;
            this.selectorDialogVisible = true;
            this.rule = row;
            this.queryGameSelector = {
                "gameIds": [],
                "gameLabels": [],
                "gameLabelIds": [],
                "startTime": '',
                "endTime": '',
                "subChannelIds": [],
                "prop": '',
                "order": '',
                "page": 1,
                "size": 10,
                "dept": '208'
            },
                //展示前清空临时已选游戏列表
                this.tempSelectedGameList = [];
            this.selectedGameList = [];
            //=========================================================初始化已选游戏列表
            //获取已选择的游戏信息 传入
            selectedDiscoverSelector(this.rule.id).then(resp => {
                //设置临时已经选择的list
                if (resp.data.info) {
                    resp.data.info.forEach((info) => {
                        //这里查询获取到的已经选择游戏
                        this.selectedGameList.push(info.video)
                    });
                    console.log(this.selectedGameList)
                }
                //调用通用数据处理方法
                this.gameSelectorTemp();
            });
            //设置生效日期
            this.useTime = new Date(row.validDate);
            this.headers = {Authorization: this.$store.state.user.token};
        },
        confirmAddSelect(preList) {
            let _this = this;
            let gameSelectors = [];
            let obj = {};
            //构造新的游戏选品list 传给后台
            gameSelectors = preList.reduce((cur, next) => {
                obj[next.id] ? "" : (obj[next.id] = true && cur.push({
                    video: {id: next.id},
                    rank: next.rank, label: next.label, weight: next.weight
                }));
                return cur;
            }, []);
            //这里 改成传入  在后台进行已有数据清空
            batchAddDiscoverSelector(_this.matchInfo().id, gameSelectors).then(resp => {
                if (resp.data.status === 0) {
                    _this.searchListMatch();
                    this.closeSelectorFormDialog();
                }
            }).catch(function () {
            });
            //调用关闭dialog接口

        },
        deleteRow(index, row) {
            this.disable = true
            this.selectedGameList.splice(index, 1);
            this.gameList.forEach(item => {
                if (item.id === row.id) {
                    this.$refs.multipleTable.toggleRowSelection(item, false);
                    this.tempSelectedGameList.forEach((game, index) => {
                        //如果删除的是临时的游戏选品 而不是已经选好的 需要清除对应templist
                        if (game.id === row.id) this.tempSelectedGameList.splice(index, 1)
                    })
                }
            })
        },

        tableRowClass: function (row) {
            if (row.rowIndex % 2 === 1) {
                return 'row_odd_class'
            }
            return ''
        },
        //  ------------------------------------这里复制逻辑
        copyRow(row) {
            this.matchEditForm = {
                "id": row.id,
                "name": "",
                "recommendCount": 0,
                "state": 0,
                "subChannels": [],
                "clicked": null
            };

            this.editDialogTitle = "复制发现页配置";
            this.editDialogVisible = true;
            this.copyFlag = true;
        },
        // 新增和编辑和复制板块使用的数据
        confirmEditFormDialog: function () {
            let _message = '';
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            //判断是否为复制操作
            if (!this.copyFlag) {
                //判断是否为新增 还是编辑
                if (this.matchEditForm.id === 0) {
                    //新增不进行复制所以第一个参数传入null
                    addDiscoverRule("", this.matchEditForm).then(resp => {
                        if (resp.data.status === 0) {
                            this.editDialogVisible = false;
                            this.searchListMatch();
                        }
                    });
                } else {
                    editDiscoverRule(this.matchEditForm).then(resp => {
                        if (resp.data.status === 0) {
                            this.editDialogVisible = false;
                            this.searchListMatch();
                        }
                    });
                }

            } else {
                //复制操作需要调用复制操作方法
                addDiscoverRule(this.matchEditForm.id, this.matchEditForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.editDialogVisible = false;
                        this.searchListMatch();
                    }
                })
                //恢复flag flase
                this.copyFlag = false;
            }


        },
        //取消编辑窗口  进行初始化
        cancleEditFormDialog() {
            this.editDialogVisible = false;
            this.copyFlag = false;
        },
        handleSelectionChange(val) {
            this.disable = true;
            let _this = this;
            val.forEach(function (game) {
                //设置默认值
                _this.$set(game, 'rank', 0);
                _this.$set(game, 'label', 0);
                _this.$set(game, 'weight', 0);
                _this.selectedGameList.forEach(function (gameSelector) {
                    if (game.id === gameSelector.id) {
                        _this.$set(game, 'rank', gameSelector.rank);
                        _this.$set(game, 'label', gameSelector.label);
                        _this.$set(game, 'weight', gameSelector.weight)
                    }
                })
            });
            _this.tempSelectedGameList = val
        },
        gameSelectorTemp() {
            //这个flag是设置watch监听事件 当跟新完当前页已选游戏标志位后再下一次渲染中设置为true
            this.flag = false
            //重要 这里是element分页的一个bug 在分页情况下切换已勾选页会重复添加已勾选数据 所以在这里清除全部勾选
            ;this.gameList.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item, false);
            });
            let newLabelIds = [];// eslint-disable-line no-unused-vars
            this.queryGameSelector.gameLabels.forEach(function (label) {
                label.forEach(function (sub, index) {
                    if (index % 2 !== 0) {
                        newLabelIds.push(sub);
                    }
                })
            });
            this.queryGameSelector.gameLabelIds = newLabelIds;
            searchDiscoverSelector(this.queryGameSelector).then(resp => {
                this.gameList = resp.data.info.content;
                this.totalElements = resp.data.info.totalElements;
                //获取已选中游戏id
                const ids = [];

                this.selectedGameList.length && this.selectedGameList.forEach(item => {
                    ids.push(item.id)
                });
                //临时temp数组
                const tempSelectedGameList = [];
                //console.log('xxxx', ids)
                //判断当前页是否有已选中游戏 如果有设置已勾选
                ids.length && this.gameList.forEach(item => {
                    if (ids.indexOf(item.id) > -1) {
                        tempSelectedGameList.push(item);
                        this.$refs.multipleTable.toggleRowSelection(item, true);
                    }
                });
                this.disable = false;
                //console.log('new page: ', tempSelectedGameList)
                //赋值
                this.tempSelectedGameList = tempSelectedGameList;
                //渲染 并设置flag为true
                this.$nextTick(() => this.flag = true)
            });
        },
        // 设置列的排序为我们自定义的排序
        handleHeaderClass({column}) {
            column.order = column.multiOrder
        },
        // 点击表头
        handleHeaderCLick(column) {
            if (column.sortable !== 'custom') {
                return
            }
            if (!column.multiOrder) {
                column.multiOrder = 'descending'
            } else if (column.multiOrder === 'descending') {
                column.multiOrder = 'ascending'
            } else {
                column.multiOrder = ''
            }
            this.handleOrderChange(column.property, column.multiOrder)
        },
        handleOrderChange(orderColumn, orderState) {
            let result = this.ordersList.find(e => e.orderColumn === orderColumn)
            if (result) {
                result.orderState = orderState
            } else {
                this.ordersList.push({
                    orderColumn: orderColumn,
                    orderState: orderState
                })
            }
            this.sort_select(this.ordersList);
        },
        handleTableSort({column}) {
            // 有些列不需要排序，提前返回
            if (column.sortable !== 'custom') {
                return
            }
            if (!column.multiOrder) {
                column.multiOrder = 'descending'
            } else if (column.multiOrder === 'descending') {
                column.multiOrder = 'ascending'
            } else {
                column.multiOrder = ''
            }
            this.handleOrderChange(column.property, column.multiOrder)
        },
        sort_change(column) {
            this.queryGameSelector.page = 1;
            //如果列空则条件清空  如果order为null手动置为空字符串 如果其他情况设置字段
            if (column.prop == null) {
                this.queryGameSelector.prop = "";
                this.queryGameSelector.order = ""
            } else {
                if (column.order == null) {
                    this.queryGameSelector.order = ""
                } else {
                    this.queryGameSelector.order = column.order
                }
                this.queryGameSelector.prop = column.prop
            }
            this.gameSelectorTemp()
        },
        sort_select(order_list) {
            let _this = this;
            for (let x in _this.selectedGameList) {
                let r = 0;
                for (let i = 0; i < order_list.length; i++) {
                    let value = order_list[i];
                    let index;
                    if (i === 0) {
                        index = 100000;
                    } else {
                        index = 1;
                    }
                    if (value.orderState === 'ascending') {
                        if (value.orderColumn === 'rank') {
                            r += index * _this.selectedGameList[x].rank;
                        } else {
                            r += index * _this.selectedGameList[x].weight;
                        }
                    } else {
                        if (value.orderColumn === 'rank') {
                            r += -index * _this.selectedGameList[x].rank;
                        } else {
                            r += -index * _this.selectedGameList[x].weight;
                        }
                    }
                }
                _this.selectedGameList[x].r = r;
            }
            _this.selectedGameList.sort(function (a, b) {
                return a.r - b.r;
            });
            console.log(_this.selectedGameList)
        },
        closeSelectorFormDialog: function () {
            this.selectedGameList = [];
            this.tempSelectedGameList = [];
            this.selectorDialogVisible = false;
        },
        handleSizeChange(newSize) {
            this.queryGameSelector.size = newSize;
            this.gameSelectorTemp()
        },
        handleCurrentChange(newPage) {
            this.queryGameSelector.page = newPage;
            this.gameSelectorTemp()
        },
        formatDate: function (row, column) {
            return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
        },
        queryGameList() {
            if (this.searchDateRange && this.searchDateRange[0] && this.searchDateRange[1]) {
                this.queryGameSelector.startTime = this.searchDateRange[0];
                this.queryGameSelector.endTime = this.searchDateRange[1]
            } else {
                this.queryGameSelector.startTime = '';
                this.queryGameSelector.endTime = ''
            }
            //  判断排序 页数置1
            this.queryGameSelector.page = 1;
            this.gameSelectorTemp()
        },
        plateInfo() {
            return this.rule;
        },
        clearAllSelected() {
            this.$refs.multipleTable.clearSelection();
            this.selectedGameList = [];
            this.tempSelectedGameList = [];
            this.disable = true;
        },
        handleSuccess(data) {
            this.selectorDialogVisible = true;
            this.queryGameSelector = {
                "gameIds": [],
                "categories": [],
                "state": 1,
                "startTime": '',
                "endTime": '',
                "subChannelIds": [],
                "prop": '',
                "order": '',
                "page": 1,
                "size": 10,
                "dept": '',
                "statusFlag": -1,
                "selectAllGameIds": [],
                "squareFlag": -1,
                "bannerFlag": -1,
                "videoFlag": -1
            };
            //展示前清空临时已选游戏列表
            this.tempSelectedGameList = [];
            this.selectedGameList = [];
            //=========================================================初始化已选游戏列表
            //获取已选择的游戏信息 传入

            if (data.info) {
                data.info.forEach((info) => {
                    //这里查询获取到的已经选择游戏
                    this.selectedGameList.push(info.video)
                });
            }
            //调用通用数据处理方法
            this.gameSelectorTemp();
            //设置生效日期
            this.useTime = new Date(this.rule.validDate);
            this.headers = {Authorization: this.$store.state.user.token};
            this.disable = true;
        },
        beforeUpload(data) {
            console.log(data);
        },
        upload() {
            return this.VUE_APP_BASE_URL + '/discover/selector/selected/excel?discoverId=' + this.rule.id;
        },
        exportExcel() {
            this.exportObject.id = this.rule.id;
            console.log(this.rule.id);
            let fileName = new Date().toLocaleString() + '发现页选品.xlsx';
            downloadData(
                '/discover/selector/excelExport',
                Object.assign(this.exportObject),
                fileName
            )
        },
        showWeight(row) {
            this.weightDialogVisible = true;
            this.discoverDetails = row;
            this.search(row.id);
        },
        search(id) {
            weightSearch(id).then(resp => {
                this.list = resp.data.info;
            });
        },
        getData() {
            return this.discoverDetails;
        },
        addWeight(discoverId) {
            this.list.push({
                id: 0,
                weight: 0,
                number: 0,
                discoverRuleId: discoverId
            })
        },
        reduceCash(index, rows) {
            rows.splice(index, 1);
        },
        cancelWeight() {
            this.weightDialogVisible = false;
            this.list = [];
        },
        confirmWeight(discoverId) {
            batchAddWeight(discoverId, this.list).then(resp => {
                if (resp.data.status == 0) {
                    this.$message({
                        message: '恭喜你，添加成功',
                        type: 'success'
                    });
                    this.search(discoverId);
                }
            });
        }
    },
    watch: {
        tempSelectedGameList: {
            handler(val, oldVal) {
                //console.log('tempSelectedGameList', val, oldVal)
                //如果是加载数据阶段设置勾选时 不进行监听直接返回
                if (!this.flag) return;
                //新增数据判断
                const isAdd = val.length > oldVal.length;
                const oldArr = [], arr = [];
                oldVal.forEach((item) => {
                    oldArr.push(item.id)
                });
                val.forEach((item) => {
                    arr.push(item.id)
                });
                //console.log('arr', oldArr, arr)
                if (isAdd) {
                    let result = [];
                    arr.forEach(id => {
                        //把新增的数据项push进结果中 result
                        if (oldArr.indexOf(id) === -1) {
                            result.push(id)
                        }
                    });
                    result.forEach(id => {
                        //新数据中如果 id为新增数据项已经初始化之后了ranklabel 则添加到selectedGameList最终结果中
                        val.forEach((item) => {
                            if (item.id === id) this.selectedGameList.push(item)
                        })
                    })
                } else {
                    //删除时
                    let result = [];
                    oldArr.forEach(id => {
                        //把删除的id找出来
                        if (arr.indexOf(id) === -1) {
                            result.push(id)
                        }
                    });
                    //把selectedGameList中对应resultId 删除
                    result.forEach(id => {
                        this.selectedGameList.forEach((item, index) => {
                            if (item.id === id) this.selectedGameList.splice(index, 1)
                        })
                    })
                }
            }
        },
    },
    created() {
        allLabels().then(resp => {
            this.labels = resp.data.info;
        });
        channelList().then(resp => {
            let _this = this;
            this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                if (channel.children) {
                    channel.children = channel.children.filter(sub => sub.state === 1)
                }
                return channel;
            }).filter(channel => channel.children && channel.children.length);
            this.channelList.forEach(function (channel) {
                _this.$set(channel, 'subChannel', channel.id);
                channel.children.forEach(function (sub) {
                    _this.subChannelList.push(sub);
                    _this.subChannels.push(sub.subChannel);
                })
            });

            searchDiscoverRules().then(resp => {
                let _this = this;
                this.rules = resp.data.info;
                //设置总条数
                this.totalSize = this.rules.length;
                this.rules.forEach(function (rule) {
                    if (rule.subChannels.length < 1) {
                        _this.$set(rule, 'subChannels', _this.subChannels);
                    } else {
                        rule.subChannels.forEach(function (subChannel) {
                            _this.subChannelList.forEach(function (sub) {
                                if (sub.subChannel === subChannel) {
                                    _this.subChannelNames.push(sub.name);
                                }
                            })
                        });

                        _this.$set(rule, 'subChannelNames', _this.subChannelNames);
                        _this.subChannelNames = [];
                    }
                })
            });
        });
        gameRunningList().then(resp => {
            this.gameSelectorList = resp.data.info;
        });
        // 获取游戏标签
        allGameLabels().then(resp => {
            this.labelList = resp.data.info;
        })
    },
    mounted() {
        //这里获取video地址
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
    }
}
</script>

<style lang="less">
.sub-sub7 {
    position: relative;
    left: 600px
}

.avatar1 {
    width: 150px;
    height: 200px;
    display: block;
}

.el-tooltip__popper {
    max-width: 50%
}
</style>
